import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SessionPage from './pages/SessionPage';
import VaultPage from './pages/VaultPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import RegulationsPage from './pages/RegulationsPage';
import CompliancePlaybooksPage from './pages/CompliancePlaybooksPage';
import ProfilePage from './pages/ProfilePage';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { VaultProvider } from './contexts/VaultContext';

function App() {
  return (
    <AuthProvider>
      <VaultProvider>
        <Router>
          <div className="min-h-screen bg-white">
            <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } />
            <Route path="/session/:sessionId" element={
              <ProtectedRoute>
                <SessionPage />
              </ProtectedRoute>
            } />
            <Route path="/vault" element={
              <ProtectedRoute>
                <VaultPage />
              </ProtectedRoute>
            } />
            <Route path="/vault/project/:projectId" element={
              <ProtectedRoute>
                <ProjectDetailPage />
              </ProtectedRoute>
            } />
            <Route path="/regulations" element={
              <ProtectedRoute>
                <RegulationsPage />
              </ProtectedRoute>
            } />
            <Route path="/compliance-playbooks" element={
              <ProtectedRoute>
                <CompliancePlaybooksPage />
              </ProtectedRoute>
            } />
            <Route path="/login" element={
              <Login />
            } />
            <Route path="/register" element={
              <Register />
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
            </Routes>
          </div>
        </Router>
      </VaultProvider>
    </AuthProvider>
  );
}

export default App;